import { createElement } from 'react'
import { Table } from 'shared/components'

export const createColumns = () => [
  {
    Header: 'Email',
    accessor: 'email',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'First Name',
    accessor: 'firstName',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'Last Name',
    accessor: 'lastName',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'Beneficiary Name',
    accessor: 'beneficiaryName',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'Role',
    accessor: 'role',
    minWidth: 300,
    width: 300,
  },
  {
    Header: 'Status',
    accessor: 'active',
    Cell: (props) => {
      return createElement(Table.CellRenderers.UserStatusCell, { ...props })
    },
  },
]
